import React from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Heading, Tabs } from "@telia/teddy";
import AllReviews from "./AllReviews";
import ReviewStatistics from "./ReviewStatistics";
import "./ReviewAdmin.less";

const TAB_ALL = "alle";
const TAB_STATS = "statistikk";

const ReviewAdmin: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") === TAB_STATS ? TAB_STATS : TAB_ALL;

    const handleTabChange = (value: string) => {
        setSearchParams(value === TAB_STATS ? { tab: TAB_STATS } : {}, { replace: true });
    };

    return (
        <Box className="review-admin">
            <Heading mb="100" as="h2" variant="title-300" className="review-admin__heading">
                Vurderinger
            </Heading>

            <Tabs value={activeTab} onValueChange={handleTabChange}>
                <Tabs.List className="review-admin__tabs">
                    <Tabs.Trigger value={TAB_ALL}>Alle vurderinger</Tabs.Trigger>
                    <Tabs.Trigger value={TAB_STATS}>Statistikk</Tabs.Trigger>
                </Tabs.List>
                <Tabs.Content value={TAB_ALL}>
                    <AllReviews />
                </Tabs.Content>
                <Tabs.Content value={TAB_STATS}>
                    <ReviewStatistics />
                </Tabs.Content>
            </Tabs>
        </Box>
    );
};

export default ReviewAdmin;
